<template>
  <section>
    <div class="row">
      <div class="offset-lg-1 col-lg-10 col-sm-12">
        <div class="step-form__main pt-3">
          <el-row>
              <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px;">Related Documents (optional)</h3>
          </el-row>
          <div v-if="this.currentFiles.length > 0">
            <div class="field">
              <div v-for="(file, index) in currentFiles" :key="index" class="file-item">
                <div class="level-top row">
                  <div class="level-left col-lg-6">
                    <div class="global-h-gutter"><svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="24" cy="24" r="24" fill="#F0F4F0"></circle> <path d="M17 16h14v17H17V16z" fill="#fff" stroke="#91C855" stroke-width="2"></path> <path d="M20.5 24.5h7M20.5 21.5h7M20.5 27.5h7" stroke="#91C855" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>
                    <div class="level-item m-l-20"><a :href="`${file.file_url}`">{{file.file_name}}</a></div>
                  </div>
                </div>

                <div class="level-bot">
                  <select class="file-type" @change="onChange(file, $event)" disabled>
                    <option v-for="(option, index) in options" :key="index">
                      {{ file.file_category }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="review-section col-lg-12 row">
            <div class="amcredit-text">Upload any documents related to you or your business. Files must be PDF, JPEG, PNG, DOC or XLS, 25mb max.</div>
            <div class="remove-padding col-lg-12">
              <multiple-uploads @ready="childVal => { uploadedFiles = childVal }" :key="fileUploadComponentKey"/>
            </div>
          </div>
          <div class="text-center">
            <el-button
              type="primary"
              :loading="isLoading"
              class="personal-center-form__submit"
              @click="submitForm"
            >submit</el-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import _ from "lodash";
// import moment from "moment";
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as types from "../../vuex/types";
// import "webuploader/css/webuploader.css";
// import jq from "jquery";
// import Webuploader from "webuploader";
// import { Loading } from "element-ui";
import api from "../../vuex/api/index";
import MultipleUploads from './../applyLoan/MultipleUploads.vue'
import axios from 'axios';

export default {
  components: {
    MultipleUploads
	},
  data() {
    return {
      isLoading: false,
      fileUploadComponentKey: 0,
      frontApplyId: '',
      currentFiles: [],
      uploadedFiles: null,
      options: [
        { text: 'What type of document is this?', value: 'What type of document is this?' },
        { text: 'Application', value: 'application' },
        { text: 'Balance Sheet', value: 'balance_sheet' },
        { text: 'Banks', value: 'banks' },
        { text: 'Bill of Sale', value: 'bill_sale' },
        { text: 'Broker Credit', value: 'broker_credit' },
        { text: 'Business Taxes', value: 'business_taxes' },
        { text: 'Comp', value: 'comp' },
        { text: 'Credit.Net', value: 'credit_net' },
        { text: 'Cross Corp', value: 'cross_corp' },
        { text: 'Cross Corp Taxes', value: 'cross_corp_taxes' },
        { text: 'Customer CLEAR', value: 'customer_clear' },
        { text: 'D&B', value: 'd_b' },
        { text: 'Experian', value: 'experian' },
        { text: 'Financials', value: 'financials' },
        { text: 'Foreign SOS', value: 'foreign_sos' },
        { text: 'Home Ownership', value: 'home_ownership' },
        { text: 'Inactive SOS', value: 'inactive_sos' },
        { text: 'Inactive Safer', value: 'inactive_safer' },
        { text: 'Individual Taxes', value: 'individual_taxes' },
        { text: 'Invoice', value: 'invoice' },
        { text: 'Misc Docs From Broker', value: 'misc_docs_broker' },
        { text: 'PG CLEAR', value: 'pg_clear' },
        { text: 'PPP - Additional Doc', value: 'ppp_additional_doc' },
        { text: 'PPP - Government ID Back', value: 'ppp_government_id_back' },
        { text: 'PPP - Government ID Front', value: 'ppp_government_id_front' },
        { text: 'PPP - Organizational Official Documents', value: 'ppp_organizational_official_documents' },
        { text: 'PPP - Payroll', value: 'ppp_payroll' },
        { text: 'PPP - Proof of Record Business', value: 'ppp_proof_of_record_business' },
        { text: 'PPP - Proof of Record Employees', value: 'ppp_proof_of_record_employees' },
        { text: 'PPP – Signature', value: 'ppp_signature' },
        { text: 'Paynet', value: 'paynet' },
        { text: 'Personal Financial Statement', value: 'personal_financial_statement' },
        { text: 'Potential Cross Corp', value: 'potential_cross_corp' },
        { text: 'Profit & Loss', value: 'profit_loss' },
        { text: 'Quote / Estimate', value: 'quote_estimate' },
        { text: 'R&D - Bank Statements', value: 'df_bank_statement' },
        { text: 'R&D - Financial or Tax Statements', value: 'df_financial_tax' },
        { text: 'R&D - SBA Proof of Funds Received', value: 'df_sba' },
        { text: 'R&D - YTD Business Financials', value: 'df_ytd' },
        { text: 'Safer', value: 'safer' },
        { text: 'Secretary of State', value: 'secretary_state' },
        { text: 'Specs', value: 'specs' },
        { text: 'Startup Questionaire', value: 'startup_questionaire' },
        { text: 'Submission Email', value: 'submission_email' },
        { text: 'Time in Business', value: 'time_business' },
        { text: 'Website', value: 'website' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      userInfo: types.GET_USER
    })
  },
  methods: {
    ...mapActions({
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),
    checkFileTypes(files) {
      var allTypesSelected = true;
      files.forEach(file => {
        if(!file.category || file.category == '') {
          allTypesSelected = false;
        }
      })
      return allTypesSelected;
    },
    submitForm() {
      this.isLoading = true;
      //save files into database
      if(this.uploadedFiles && this.uploadedFiles.length > 0) {
        if(!this.checkFileTypes(this.uploadedFiles)) {
          this.setFailMessage({
            show: true,
            content: "Please select types for all uploaded documents first!"
          });
          return this.isLoading = false;
        }

        var filesToSave = {
          files: this.uploadedFiles,
          application_id: this.frontApplyId
        }
        axios.post("https://api.amcredit.com/apply/update", filesToSave)
          .then(res => {
            this.setSuccessMessage({
              show: true,
              content: "Submission successful!"
            });
            this.updateUploadedFiles();
            this.isLoading = false;
          });
      } else {
        this.setFailMessage({
          show: true,
          content: "You didn't upload any files yet!"
        });
        this.isLoading = false;
      }
    },
    updateUploadedFiles() {
      this.getPersonalInitData({
        token: this.userInfo.token,
        customerId: this.userInfo.crmCustomerId
      }).then(res => {
        if (Number(res.data.code) === 0) {
          const data = res.data.result;
          this.frontApplyId = data.employer.frontApplyId;
          this.currentFiles = [];
          api.getApplicationFiles(this.frontApplyId).then(res => {
            res.data.files.forEach(file => {
              this.currentFiles.push(file);
            })
            this.fileUploadComponentKey += 1;
          })
        }
      });
    }
  },
  mounted() {
    this.updateUploadedFiles();
  }
}
</script>

<style lang="scss">
  .file-item {
    a {
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    }
  }
  .remove-padding {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .review-section {
    .m-t-30 {
      margin-top: 1.875rem;
    }
    .amcredit-text {
      color: #053A7A;
      font-family: Montserrat,sans-serif,"Helvetica Neue",sans-serif;
    }
    .sub-title-margin {
      margin-top: 35px;
    }
  }
</style>


// WEBPACK FOOTER //
// FileUpload.vue?8c014e3c